const SearchFilterFunction = (e, items, items2, noData) => {
    let text = e.currentTarget.value.toString().replace(/[�"*�%()\[\]{}=\\?�`'#<>|,;:+_]+/g, "");;
    var text2 = text.toLowerCase();
    let trucks = items2;
    let filteredName = trucks.filter((item) => {
        return Object.keys(item).some((key) => (item[key] !== undefined && item[key] !== null) ? item[key].toString().toLowerCase().search(text2) !== -1 : null);
    })
    if (!text || text === '') {
        items = items2;
    }
    else if (!Array.isArray(filteredName) && !filteredName.length) {
        noData = true;
    }
    else if (Array.isArray(filteredName)) {
        noData = false;
        items = filteredName;
    }
    return { items, noData }
}
export default SearchFilterFunction

// const SearchFilterFunction = (text, items, items2, noData) => {
//   // sanitize the text
//   let cleanText = text.toString().replace(/[�"*�%()\[\]{}=\\?�`'#<>|,;:+_]+/g, "");
//   let textLower = cleanText.toLowerCase();

//   let trucks = items2;
//   let filteredName = trucks.filter((item) => {
//     return Object.keys(item).some((key) =>
//       item[key] !== undefined && item[key] !== null
//         ? item[key].toString().toLowerCase().includes(textLower)
//         : false
//     );
//   });

//   if (!text || text === '') {
//     items = items2;   // no search text → return all items
//     noData = false;
//   } else if (Array.isArray(filteredName) && !filteredName.length) {
//     noData = true;    // text present but no matches
//   } else {
//     noData = false;
//     items = filteredName;
//   }

//   return { items, noData };
// };

// export default SearchFilterFunction;

// const SearchFilterFunction = (text, items, items2, noData) => {
//   // sanitize the text and trim spaces
//   let cleanText = text.toString().replace(/[�"*�%()\[\]{}=\\?�`'#<>|,;:+_]+/g, "").trim();
//   let textLower = cleanText.toLowerCase();

//   // if search text is empty, return all items
//   if (!textLower) {
//     return { items: items2, noData: false };
//   }

//   // filter items
//   let filteredName = items2.filter((item) => {
//     return Object.keys(item).some((key) =>
//       item[key] !== undefined && item[key] !== null
//         ? item[key].toString().toLowerCase().includes(textLower)
//         : false
//     );
//   });

//   // check if filtered result is empty
//   if (filteredName.length === 0) {
//     return { items: [], noData: true };
//   } else {
//     return { items: filteredName, noData: false };
//   }
// };

// export default SearchFilterFunction;
